import React, { useState } from 'react';
import { Typography, Container, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TableTabs from './table-tab';
import { useTranslate, usePermissions } from 'react-admin';

const useStyles = makeStyles(theme => ({
    container: {
        paddingTop: theme.spacing(8.5),
        paddingBottom: theme.spacing(6),
    },
    mainText: {
        color: '#4f5064',
        fontFamily: 'UniviaPro-Medium',
        lineHeight: "21.6px",
        fontSize: 18,
        fontWeight: '500',
        letterSpacing: 'normal'

    },
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    }
}));

export default function Index() {
    const classes = useStyles();
    const [totalItems, setTotalItems] = useState(0);
    const translate = useTranslate();
    const { permissions, loaded } = usePermissions();
    if (!loaded) return null
    const isPermission = permissions.functionAction.find(value => value.function === 'Alarms')
    return (
        <Container className={classes.container}>
            <Box mb={2.5} display="flex" flexDirection="row" alignItems="center">
                <Typography className={classes.mainText}>{translate('resources.alarm.alarm')}</Typography>
                <Typography className={classes.subText}>({totalItems})</Typography>
            </Box>
            <TableTabs totalItems={totalItems} setTotalItems={setTotalItems} isUpdate={isPermission.isUpdate} isCreate={isPermission.isCreate} isDelete={isPermission.isDelete} />
        </Container>
    );
}
